package navigation.settings.currency

import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.core.settings.ui.AllowedCurrenciesEvent
import com.essntl.core.settings.ui.AllowedCurrenciesNavigation
import com.essntl.features.currency.ui.addcurrency.AddCurrencyEvent
import com.essntl.features.currency.ui.addcurrency.components.AddCurrencyDialog
import com.essntl.features.currency.ui.allowedcurrencies.AllowedCurrenciesScreen
import navigation.settings.currency.addcurrency.AddCurrencyScreenModel
import navigation.settings.currency.allowedcurrencies.AllowedCurrenciesScreenModel
import navigation.utils.NavLinkScreen

class CurrencyScreenNav(
    private val onRefresh: (() -> Unit) -> Unit,
) : NavLinkScreen {
    override val defaultTitle: String get() = "Currency"

    @Composable
    override fun Content() {
        val allowedCurrenciesScreenModel = koinScreenModel<AllowedCurrenciesScreenModel>()
        val allowedCurrenciesState by allowedCurrenciesScreenModel.state.collectAsState()

        val addCurrencyScreenModel = koinScreenModel<AddCurrencyScreenModel>()
        val addCurrencyState by addCurrencyScreenModel.state.collectAsState()
        var openAddCurrencyDialog by rememberSaveable { mutableStateOf(false) }

        LaunchedEffect(Unit) {
            allowedCurrenciesScreenModel.onEvent(AllowedCurrenciesEvent.GetAllowedCurrencies)
            onRefresh {
                allowedCurrenciesScreenModel.onEvent(AllowedCurrenciesEvent.GetAllowedCurrencies)
            }
        }

        LaunchedEffect(addCurrencyState.addCurrency.isSuccess) {
            if (addCurrencyState.addCurrency.isSuccess) {
                addCurrencyState.addCurrency.data?.let { c ->
                    allowedCurrenciesScreenModel.onEvent(AllowedCurrenciesEvent.UpdateAllowedCurrencies(c))
                }

                addCurrencyScreenModel.onEvent(AddCurrencyEvent.ClearState)
                openAddCurrencyDialog = false
            }
        }

        AllowedCurrenciesScreen(
            state = allowedCurrenciesState,
            onEvent = allowedCurrenciesScreenModel::onEvent,
            onNavigation = { nav ->
                when (nav) {
                    AllowedCurrenciesNavigation.AddCurrency -> openAddCurrencyDialog = true
                }
            },
        )

        AddCurrencyDialog(
            configurationCurrency = allowedCurrenciesState.getAllowedCurrencies.data,
            state = addCurrencyState,
            onEvent = addCurrencyScreenModel::onEvent,
            openDialog = openAddCurrencyDialog,
            onDismissRequest = { openAddCurrencyDialog = false },
        )
    }
}